if (document.querySelector('.theme-2026')) {
  const button = document.querySelector('.tickets-module__item-button.sticky-buttons');
  const row = button?.closest('.tickets-module__item-row');

  const updateStickyButton = () => {
    const rect = row.getBoundingClientRect();
    const buttonHeight = button.offsetHeight;
    const viewportHeight = window.innerHeight;

    const fixedTop = viewportHeight - buttonHeight - 25;

    button.classList.toggle('is-sticky', rect.bottom > fixedTop + buttonHeight);
  };

  if (button && row) {
    window.addEventListener('scroll', updateStickyButton);
    window.addEventListener('resize', updateStickyButton);
    updateStickyButton();
  }
}
